module.exports = __webpack_public_path__ + "static/media/cipher.060d77b8.svg";